import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { TcsmStates } from '../../root/tcsm-model';
import { TcsmSiteSettingsProps } from '../models/epi-model';
import { NavigationOption } from '../models/generic-models';


interface DropdownNavigationProps {
	options: NavigationOption[];
}

export const DropdownNavigation = (props: DropdownNavigationProps) => {
	const { options } = props;
	const history = useHistory();
	const container = useRef(null);
	const [ariaExpand, setAriaExpand] = useState(false);
	const [ariaHidden, setAriaHidden] = useState(true);
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);

	const close = () => {
		setAriaExpand(false);
		setAriaHidden(true);
	};

	const open = () => {
		setAriaExpand(true);
		setAriaHidden(false);
	};

	const handleTriggerClick = () => {
		if (ariaExpand && !ariaHidden) {
			close();
		} else {
			open();
		}

	};

	const handleOutsideClick = (e: Event) => {
		if (!container?.current?.contains(e.target as HTMLElement)) {
			close();
		}
	};

	useEffect(() => {
		window.addEventListener('click', handleOutsideClick);
	}, [container]);

	const onChange = (item: NavigationOption) => {
		if (item?.deepLink) window.location.href = item?.value;
		else history.push(item?.value);
		close();
	};

	const pathname = window.location?.pathname?.toLowerCase();
	const defaultValue = options?.find(a =>
		(a.value?.length > 0 && pathname.includes(a.value.toLowerCase())) ||
		(a.fallbackMatch?.length > 0 && pathname.includes(a.fallbackMatch?.toLowerCase())));

	return (
		<>
			<p className='nav-secondary-label'><strong>{siteSettings?.secondaryNavLabel}</strong></p>
			<div ref={container} className='nav-secondary'>
				<button type='button' className='nav-secondary-trigger ' aria-expanded={ariaExpand} onClick={handleTriggerClick}> <span>{defaultValue?.text}</span><svg className='info-icon' focusable='false'>
					<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#small-chevron-icon' />
				</svg></button>
				<div className='nav-secondary-panel' aria-hidden={ariaHidden}>
					<ul>
						{props.options?.map((l, idx) => { return <li key={`${idx}-${l.text}`}><button type='button' className='nav-secondary-link' onClick={() => onChange(l)}>{l.text}</button></li>; })}
					</ul>

				</div>
			</div>

		</>
	);
};